import Vue from 'vue'
import errorHandler from '@/utils/errorHandler'
import ComplementTransformer from '@/transformers/taxReceipt/complement'

export default (complememt) => {
  const payload = ComplementTransformer.send(complememt)
  return errorHandler(
    Vue.$http.post('taxreceipt/taxreceipt/addComplement/', payload), {
      keysTranslation: {
        warning: 'Advertencia',
      }
    })
    .then((response) => {
      let data = response.data
      return ComplementTransformer.fetch(data)
    })
}


// WEBPACK FOOTER //
// ./src/services/taxReceipt/uploadComplement.js